import CountryService from '../../services/CountryService';
import AuthService from '../../services/AuthService';

const findPrice = (
  prices: Array<any> | null, 
  recommended: boolean = false, 
  vatRate: number | null = null,
  sourceObject: any | null = null,
) => {
  if (prices === null) {
    return null;
  }
  
  if (!prices) {
    return 0;
  }

  const { currency } = CountryService.GetInstance();
  if (!currency) {
    return 0;
  }

  const priceObject = prices.find(p => p.currencyId === currency.id);

  if (!priceObject) {
    return 0;
  }

  let customerGroupsOnlyDiscountIds: Array<string> = []; 

  // ceny produktu, nebo varianty
  const fromProductPrices = (sourceObject && sourceObject.__typename 
    && (['product', 'productvariant']).indexOf(sourceObject.__typename.toLowerCase()) !== -1);

  let discountableProduct = true;
  if (sourceObject && (`productvariant`.indexOf(sourceObject.__typename.toLowerCase()) != -1 ) ) {
    if (sourceObject.product && sourceObject.product.neverApplyCustomerDiscounts ) {
      discountableProduct = false;
    }

    if ( sourceObject.product && sourceObject.product.customerGroupsOnlyDiscountIds ) {
      customerGroupsOnlyDiscountIds = [...sourceObject.product.customerGroupsOnlyDiscountIds];
    }

  } else if (sourceObject && (`product`.indexOf(sourceObject.__typename.toLowerCase()) != -1 ) ) {
    if (sourceObject.neverApplyCustomerDiscounts) {
      discountableProduct = false;
    }

    if (sourceObject.customerGroupsOnlyDiscountIds) {
      customerGroupsOnlyDiscountIds = [...sourceObject.customerGroupsOnlyDiscountIds];
    }
  }

  // ceny
  let priceWithout = priceObject && priceObject.priceWithout ? priceObject.priceWithout || 0 : 0;
  let recommendedPriceWithout = priceObject && priceObject.recommendedPriceWithout ? priceObject.recommendedPriceWithout || 0 : 0;
  const minimalPrice = priceObject && priceObject.minimalPrice ? priceObject.minimalPrice || 0 : 0;
  
  // sleva
  let discount = 0;
  // přihlášený zákazník se slevou
  const customer = AuthService.GetInstance().customer;

  // sleva podle zákazníka, nebo zákaznické skupiny
  if (customer && discountableProduct ) {
    const customerGroups: Array<GQL.ICustomerGroup> = [...(customer.customerGroups || [])];
    if (customer.customerGroup) {
      customerGroups.push(customer.customerGroup);
    }

    if (customer.customerGroups) {
      customer.customerGroups.forEach((cGroup) => {
        if (cGroup.discount && cGroup.discount > discount &&
          (customerGroupsOnlyDiscountIds?.length > 0 && customerGroupsOnlyDiscountIds?.indexOf(cGroup.id) > -1)) {
          discount = cGroup.discount;
        }
      });
    } else {
      console.log('Customer does not have customer groups set');
    }

    // sleva zákazníka
    // původně tady bylo toto:
    // if (customer.discount && customer.discount > discount) {
    //   discount = customer.discount;
    // }
    // ale podle pokynu Pavla Krčila ze dne 23. 6. 2020 provedena úprava, aby sleva nastavená přímo u zákazníka vždy měla nejvyšší prioritu
    if (customer.discount && customerGroupsOnlyDiscountIds.length < 1) {
      discount = customer.discount;
    }
  }

  // omezení na max. slevu
  if (discount > 100) {
    discount = 100;
  }

  // započítání slevy
  if (discount > 0) {
    // sleva se bude vztahovat pouze na ceny produktů
    if (fromProductPrices) {
      recommendedPriceWithout = priceWithout;
      priceWithout = (priceWithout / 100) * (100 - discount);
    }
  } 

  // cena z objektu Price
  let currPrice = priceWithout;
  if (recommended === true) {
    currPrice = recommendedPriceWithout;
  }

  currPrice = Math.max(Number(currPrice), Number(minimalPrice)) || currPrice;

  // výstup bude cena vč. DPH
  if (vatRate && vatRate > 0) {
    return (currPrice / 100) * (100 + vatRate);
  }
  
  return currPrice;
};

export default findPrice;



// WEBPACK FOOTER //
// ./src/helpers/prices/findPrice.ts